import { Reward, RewardClaim } from 'entity/reward/rewardTypes';
import { markRewardUseRequest } from 'entity/reward/rewardRedux';
import api from 'entity/reward/rewardApi';
import { Message } from 'seedly-component-library';
import { saveAs } from 'file-saver';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as Sentry from '@sentry/nextjs';

const useClaimReward = (reward: Reward, claim: RewardClaim) => {
  const dispatch = useDispatch();

  const handleClaimReward = useCallback(() => {
    if (claim) {
      dispatch(
        markRewardUseRequest({ rewardId: reward.id, claimId: claim.id }),
      );

      // from stash API, open new tab
      if (claim.reward_type === 'url') {
        window.open(claim.content, '_blank').focus();
      }

      // from seedly as PDF
      if (claim.reward_type === 'file') {
        api
          .downloadReward(reward.id)
          .then(file => {
            try {
              const blob = new Blob([file.data], {
                type: 'application/pdf',
              });
              saveAs(blob, `${reward.title}.pdf`);
            } catch (e) {
              Sentry.captureException(e);
            }
          })
          .catch(e => {
            Sentry.captureException(e);
          });
      }

      if (claim.reward_type === 'text') {
        // copy clipboard only allow on https
        if (window.isSecureContext) {
          navigator.clipboard.writeText(claim.content);
          Message.success('Copied code');
        }
      }
    }
  }, [reward, claim, dispatch]);

  return handleClaimReward;
};

export default useClaimReward;
